import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "AppsWidget",
  "use": "AppsWidget-usage",
  "viewBox": "0 0 61 60",
  "content": "<symbol viewBox=\"0 0 61 60\" xmlns=\"http://www.w3.org/2000/svg\" id=\"AppsWidget\"><g transform=\"translate(-5 -6)\" fill=\"none\" fill-rule=\"evenodd\"><ellipse fill=\"#000\" cx=\"35.5\" cy=\"36\" rx=\"30.5\" ry=\"30\" /><ellipse fill=\"#FFF\" cx=\"35.5\" cy=\"36\" rx=\"26.5\" ry=\"26\" /><path fill=\"#000\" d=\"M19 28h8v-8h-8zM32 28h8v-8h-8zM44 28h8v-8h-8zM19 40h8v-8h-8zM32 40h8v-8h-8zM44 40h8v-8h-8zM19 52h8v-8h-8zM32 52h8v-8h-8zM44 52h8v-8h-8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol